module.exports = __webpack_public_path__ + "img/garage.b83be8eb.jpeg";